// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Icon$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";

function PlaceOrderSummaryCmp(Props) {
  var fare_info = Props.fare_info;
  var bill_details = Props.bill_details;
  var match = CountryContext.useContext(undefined);
  var symbol = CountryConfig.getSymbol(match.country);
  var getTileCmp = function (title, value, className) {
    if (value !== undefined) {
      return React.createElement("div", {
                  className: "tile " + className
                }, React.createElement("p", undefined, title), React.createElement("p", undefined, Currency.toCurrencyString(Caml_option.valFromOption(value), symbol)));
    } else {
      return null;
    }
  };
  var toolTipCmp = function (param) {
    return React.createElement("div", {
                className: "tooltip"
              }, React.createElement(Icon$Catalyst.InfoIcon.make, {}), React.createElement("div", {
                    className: "tooltinfo breakup-info"
                  }, React.createElement(React.Fragment, undefined, Belt_Array.map(bill_details.fare_breakup, (function (fare) {
                              if (typeof fare === "number") {
                                return null;
                              }
                              var fare_data = fare._0;
                              return getTileCmp(fare_data.title, Caml_option.some(fare_data.value), "");
                            }))), getTileCmp("Net Fare", Caml_option.some(bill_details.net_fare), "net_fare"), getTileCmp("Previous Dues", bill_details.previous_dues, ""), getTileCmp("Porter Gold Fee", bill_details.porter_gold_fee, ""), getTileCmp("Porter Credit Applied", bill_details.porter_credits_applied, ""), getTileCmp("Amount Payable", Caml_option.some(bill_details.amount_payable), "total")));
  };
  return React.createElement("div", {
              className: "paymnet_summary"
            }, React.createElement(React.Fragment, undefined, Belt_Array.map(bill_details.fare_breakup, (function (fare) {
                        if (typeof fare === "number") {
                          return null;
                        }
                        switch (fare.TAG | 0) {
                          case /* TripFare */0 :
                              var fare_data = fare._0;
                              return React.createElement("div", {
                                          className: "tile"
                                        }, React.createElement("p", {
                                              className: "label"
                                            }, React.createElement("span", undefined, fare_data.title), toolTipCmp(undefined)), React.createElement("p", undefined, Currency.toCurrencyString(fare_data.value, symbol)));
                          case /* CouponDiscount */3 :
                              var fare_data$1 = fare._0;
                              var coupon = fare_info.applied_coupon;
                              var title = coupon !== undefined ? "Coupon applied \"" + coupon + "\"" : fare_data$1.title;
                              return getTileCmp(title, Caml_option.some(fare_data$1.value), "");
                          case /* GSTCharges */6 :
                          case /* VAT */7 :
                              break;
                          default:
                            return null;
                        }
                        var fare_data$2 = fare._0;
                        return getTileCmp(fare_data$2.title, Caml_option.some(fare_data$2.value), "");
                      }))), getTileCmp("Net Fare", Caml_option.some(bill_details.net_fare), "net_fare"), getTileCmp("Previous Dues", bill_details.previous_dues, ""), getTileCmp("Porter Gold Fee", bill_details.porter_gold_fee, ""), getTileCmp("Porter Credit Applied", bill_details.porter_credits_applied, ""), getTileCmp("Amount Payable", Caml_option.some(bill_details.amount_payable), "total"));
}

var make = PlaceOrderSummaryCmp;

export {
  make ,
  
}
/* react Not a pure module */
